export default {

 home: {
    title: 'Home',
    login: 'Login'
  },
  orderTabs: {
    all: 'All',
    refund: 'Refund'
  },
  payment: {
     returnAndComplete: 'Please return to the Alipay mini program and click to complete payment',
      processing: 'Processing payment...',
  processingTimeout: 'Payment timeout',
  getPaymentInfoFailed: 'Payment failed',
  requestFailed: 'Request failed'
},
  common: {
      captchaError: 'Incorrect CAPTCHA',
    coupon_already_claimed:"​Coupon already claimed. Scan again.",
    coupon_expired:"​This code has expired. Please obtain a new code.",
    scan_again:"Rescan",
    strfa:"Scroll to Read Full Agreement",
    all: 'All',
    cancel: 'Cancel',
    confirm: 'Confirm',
    prompt: 'Prompt',
      useConsumerVoucher: 'Use Voucher',
  showVoucherToStaff: 'Show voucher to staff',
  scanToRedeem: 'Scan with Merchant Connect',
    loading: 'Loading',
    loadFailed: 'Load failed',
    loginSuccess: 'Login successful',
    loggingIn: 'Logging in',
    pleaseLogin: 'Please log in first',
    noContent: 'No content yet~',
    loadMore: 'Loading more...',
    loadedAll: 'All data loaded',
    noMore: 'No more data~',
    missingParam: 'Missing parameter',
    pendingConfirm: 'Pending confirmation',
    pendingPay: 'Pending payment',
    completed: 'Completed',
    refunded: 'Refunded',
    processing: 'Processing',
    refunding: 'Refunding',
    pendingDelivery: 'Pending shipment',
    pendingVerification: 'Pending verification',
    verified: 'Verified',
    expired: 'Expired',
    partialRefund: 'Partial refund',
    used: 'Used',
    myOrders: 'My Orders',
    myCoupons: 'My Coupons',
    pageOpenFailed: 'Failed to open page',
    viewOrder: 'View Order',
    paySuccess: 'Payment Successful',
    more: 'More',
    collapse: 'Collapse',
    notSupportedYet: 'Not supported yet. Stay tuned~',
    mr: 'Mr.',
    ms: 'Ms.'
  },
  auth: {
    welcomeTitle: 'Welcome to Find Macau',
    welcomeDesc: 'Please feel free to use after authorization login',
    welcomeDescProtected: 'Your information will be protected',
    authorizeLogin: 'Authorize Login',
    authorizationSuccess: 'Authorization successful',
    agreementTitle: 'Confirm Information',
    agreementConfirmText: 'Agree & Claim',
    agreementScrollTip: 'Please read all terms of the above agreements carefully',
    login: {
      appTitle: 'FindMacau',
      phoneRegister: 'Phone Sign Up',
      phoneLogin: 'Phone Login',
      emailRegister: 'Email Sign Up',
      emailLogin: 'Email Login',
      placeholderPhone: 'Enter phone number',
      placeholderEmail: 'Enter email',
      placeholderPassword: 'Enter password',
      placeholderCode: 'Enter verification code',
      forgetPassword: 'Forgot password',
      sendCode: 'Send code',
      resendAfterSeconds: 'Resend in {count}s',
      accountLogin: 'Account login',
      codeLogin: 'Code login',
      agreementWithApp: 'I have read and agree to FindMacau',
      termsOfUse: 'Terms of Use',
      and: 'and',
      privacyPolicy: 'Privacy Policy',
      registerNow: 'Sign Up',
      retrievePassword: 'Reset Password',
      alreadyHaveAccount: 'Already have an account?',
      noAccountYet: "Don't have an account?",
      quickLogin: 'Quick Login',
      quickRegister: 'Quick Sign Up',
      thirdPartyLogin: 'Third-party login',
      humanVerifyTitle: 'Verification',
      refreshCaptcha: 'Click to refresh captcha',
      captchaUpdateHint: 'Click the image to refresh the captcha',
      toast: {
        phoneEmpty: 'Phone number is required',
        phoneInvalidFormat: 'Invalid phone number format',
        emailEmpty: 'Email is required',
        emailInvalid: 'Please enter a valid email',
        emailFillCorrectly: 'Please enter a valid email',
        mustAgreeTerms: 'You must agree to the terms to sign up',
        passwordInvalid: 'Please enter a valid password',
        passwordRule: 'Please enter a 6-18 character password with letters and numbers',
        codeInvalid4: 'Please enter a valid 4-digit code',
        codeSentSms: 'Verification code sent. Please check your SMS.',
        codeSentEmail: 'Verification code sent. Please check your email.',
        passwordUpdated: 'Password updated. Please log in again.'
      }
    }
  },
  coupon: {
    useNow: "Use Now",
        useMethod: "Usage",
    todaySoldOut: 'Sold out today',
      qrCodeTitle:'Coupon QR Code',
      paused:"Coupons paused. Try again later.",

      qrCodeTip:'Please scan the QR code',
    soldOut: 'Sold out',
     unused: 'Unused',

      used: 'Used',

      expired: 'Expired',

      myOrders: 'My Orders',
    termsOfUse: 'Terms of Use',
    details: 'Details',
    bookingWebsite: 'Booking Website',
    goOfficialBooking: 'Go to official website to book',
    otherRules: 'Event Rules',
    receiveNow: 'Claim Now',
    receiveSuccess: 'Claimed successfully',
    systemPrompt: 'System Prompt',
    confirmUseQuestion: 'Confirm to use?',
    useTime: 'Usage Time',
    couponQrTitle: 'Coupon QR Code',
    showQrToMerchant: 'Please show the QR code to the merchant',
    scanToVerify: 'Please use "Merchant Pass" to scan and verify this coupon',
    couponCode: 'Coupon Code',
    couponDetailsLoadFailed: 'Failed to load coupon details',
    exchange: 'Redeem',
    inputCouponCode: 'Please enter coupon code',
    exchangeSuccess: 'Redeemed successfully',
    couponOrCode: 'Coupon / Promo Code',
    couponTitle: 'Coupon',
    qrClosed: 'QR code closed',
    detailTitle: 'Coupon Details',
    scannerTip: 'Please place the QR code inside the frame',
    cameraStartFailed: 'Failed to start camera:',
    qrNotExpired: 'QR code has not expired',
    noCoupons: 'No coupons available',
    pendingPayment: 'Pending Payment',
    viewNow: 'View Now',
    afterSales: 'After-sales',
    newArrival: 'New',
    noMoreCoupons: 'No more coupons',
    exchangeSuccess: 'Redeemed successfully'
  },
  order: {
    goodsTotal: 'Subtotal',
    discount: 'Discount',
    actualPayment: 'Actual Payment',
    eVoucher: 'E-voucher',
    orderNumber: 'Order Number',
    paymentTime: 'Payment Time',
    contactSupport: 'Contact Support',
    viewCredential: 'View Voucher',
    scanMerchantQr: 'Please scan the merchant QR code',
    writeReview: 'Write Review',
    viewReview: 'View Review',
    orderAmount: 'Order Amount',
    discountCannotStack: 'Discounts cannot be combined with payment instant discounts',
    paymentMethod: 'Payment Method',
    wechatPay: 'WeChat Pay',
    detail: 'Details',
    total: 'Total',
    pay: 'Pay',
    payAmount: 'Amount Due',
    payProcessing: 'Processing...',
    payTimeout: 'Payment timed out, please pay again',
    createOrderFailed: 'Failed to create order',
    paymentFailed: 'Payment failed',
    continuePay: 'Continue Payment',
    finishedPay: 'Payment Completed',
    wechatPayGuideLine1: "1. If WeChat is not opened or payment is not finished, tap 'Continue Payment';",
    wechatPayGuideLine2: "2. If payment is completed, tap 'Payment Completed';",
    paymentNotCompleted: 'You have not completed the payment yet. Please try again after payment.',
    longPressViewOrder: 'Long press to view order',
    click: 'Click',
    backHome: 'Back to Home',
    autoRedirectMyOrders: 's before automatically redirecting to My Orders',
    merchant: 'Merchant',
    finish: 'Finish',
    paidSuccess: 'Payment Successful',
    orderDetail: 'Order Details',
    payResult: 'Payment Result',
    alipay: 'Alipay',
    alipayMacau: 'Alipay (Macau)',
    alipayBOC: 'Alipay',
    mpay: 'MPay',
    bocPay: 'BOC Pay',
    creditCardPay: 'Credit Card Payment',
    icbcEpay: 'ICBC E-Pay',
    icbcCreditCardPay: 'ICBC Credit Card',
    taiFungPay: 'Tai Fung Pay',
    bocWechatPay:"WeChat Pay",
  },
  qrcodepay: {
    followFindMacauOfficial: 'Follow the "FindMacau" official WeChat account',
    moreExcitingAwait: 'More exciting updates are waiting for you!',
    longPressScanQr: 'Long press to scan the QR code',
    follow: 'Follow',
    findMacau: 'FindMacau',
    officialAccountDesc: 'Official account for the latest city updates',
    instantDiscount: 'Spend {base} save ￥{amount}',
    myMiniProgram: 'My Mini Program'
  },
  share: {
    homeTitle: 'Macau Travel and Experience Booking',
    homeDesc: 'Tickets, dining, hotels and SIM cards in one place, with local deals from 10% off.',
    couponTitle: 'Psst! A stack of Macau travel coupons for you',
    couponDesc: 'Worth over 1000+ in value. Grab the coupons before you go!'
  },
   scan: {
    putQrCodeInFrame: 'Place the QR code inside the frame',
    openingCamera: 'Opening camera...',
    cameraErrorTitle: 'Unable to access camera',
    cameraErrorText: 'Unable to access camera',
    reopen: 'Reopen',
    scanning: 'Scanning QR code...',
    closeFlash: 'Turn off flashlight',
    openFlash: 'Turn on flashlight',
    torchNotSupported: 'This device does not support flashlight'
  },
   title: {
      order: 'Coupon Order List',
      orderDetail: 'Coupon Order Details',
      payment: 'Submit Payment',
      paySuccess: 'Payment Successful',
      couponDetail: 'Voucher',
      couponList: 'Coupon List'
    }
}



// WEBPACK FOOTER //
// ./src/i18n/locales/en.js